import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { authCode } from "../../api/auth_code"
import { authCodeRegenerate } from "../../api/auth_code_regenerate"
import { useLoading } from "../LoadingContext"
import { Link } from "react-router-dom"
import MDBox from "components/MDBox"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"
import { Card } from "@mui/material"
import BasicLayout from "../components/BasicLayout"

function AuthCodePage() {
  const { startLoading, stopLoading } = useLoading()
  const [inputAuthCode, setInputAuthCode] = useState<string>("")
  const [errorMessage, setErrorMessage] = useState<string>("")
  const navigate = useNavigate()

  const handleAuthCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputAuthCode(e.target.value)
  }

  const validate = () => {
    let hasError = false

    // 必須項目のバリデーション
    if (!inputAuthCode || inputAuthCode == "") {
      setErrorMessage("必須項目が入力されていません")
      hasError = true
    } else if (inputAuthCode.length != 6) {
      setErrorMessage("入力文字数は6文字です")
      hasError = true
    } else {
      setErrorMessage("")
    }

    return !hasError
  }

  const handleSubmit = async () => {
    if (validate()) {
      try {
        startLoading()
        await authCode(inputAuthCode)
        setErrorMessage("")

        const is_initialize = localStorage.getItem("is_initialize")
        if (is_initialize === "1") {
          navigate("/home") // 認証成功後にダッシュボードへ
        } else {
          navigate("/initialize-password") // 認証成功後にダッシュボードへ
        }
      } catch (error: any) {
        // エラーハンドリング
        if (error.response && error.response.status === 401) {
          navigate("/login") // セッション切れ
        } else if (error.response && (error.response.status === 402 || error.response.status === 403)) {
          // 認証コードの入力エラー又は、認証コードの有効期限切れ
          const errorDetail = error.response.data.detail
          setErrorMessage(errorDetail.message)
        } else if (error.response && error.response.status === 423) {
          // ロックされている
          setErrorMessage("")
          navigate("/lock")
        } else {
          setErrorMessage("サーバーへの接続に失敗しました")
        }
      } finally {
        stopLoading()
      }
    }
  }

  const handleCodeRegenerate = async () => {
    try {
      await authCodeRegenerate()
      setErrorMessage("認証コード再送しました")
    } catch (error: any) {
      // エラーハンドリング
      if (error.response && error.response.status === 401) {
        navigate("/login") // セッション切れ
      } else {
        setErrorMessage("サーバーへの接続に失敗しました")
      }
    }
  }

  return (
    <BasicLayout>
      <Card>
        <MDBox textAlign="center" pt={6} pb={4}>
          <MDTypography variant="h4" fontWeight="medium" mb={3}>
            認証コード入力
          </MDTypography>
        </MDBox>
        <MDBox px={6} pb={4}>
          <MDBox component="form" role="form">
            <MDBox mb={1}>
              <MDInput
                type="number"
                label="認証コード"
                value={inputAuthCode}
                onChange={handleAuthCodeChange}
                fullWidth
                sx={{
                  padding: "2px",
                  fontSize: "0.9rem",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    "& fieldset": {
                      borderColor: "rgba(0, 0, 0, 0.1)"
                    },
                    "&:hover fieldset": {
                      borderColor: "rgba(0, 0, 0, 0.2)"
                    }
                  }
                }}
              />
            </MDBox>
            {errorMessage && (
              <MDBox
                color="#FF0000" // テキスト色
                mb={2} // 下マージン
                fontSize="0.7em" // フォントサイズ
              >
                {errorMessage}
              </MDBox>
            )}

            <MDBox textAlign="center" sx={{ mt: 3 }}>
              <MDButton
                variant="contained"
                color="info"
                fullWidth
                sx={{
                  borderRadius: "4px",
                  textTransform: "none",
                  fontSize: "1rem",
                  padding: "0.75rem 0",
                  backgroundColor: "#1976d2",
                  "&:hover": {
                    backgroundColor: "#1565c0"
                  }
                }}
                onClick={() => {
                  //console.log("Login button clicked!");
                  handleSubmit()
                }}
              >
                送信
              </MDButton>
            </MDBox>
            <MDBox textAlign="center" sx={{ mt: 3, mb: 2 }}>
              <MDButton
                variant="contained"
                color="info"
                fullWidth
                sx={{
                  borderRadius: "4px",
                  textTransform: "none",
                  fontSize: "1rem",
                  padding: "0.75rem 0",
                  backgroundColor: "#1976d2",
                  "&:hover": {
                    backgroundColor: "#1565c0"
                  }
                }}
                onClick={() => {
                  //console.log("Login button clicked!");
                  handleCodeRegenerate()
                }}
              >
                認証コード再送
              </MDButton>
            </MDBox>
            <MDBox textAlign="right">
              <MDTypography
                component={Link}
                to="/login"
                variant="button"
                color="info"
                sx={{ textDecoration: "none", pr: 2 }}
              >
                戻る
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  )
}

export default AuthCodePage
